/**
 * Complaints Form Handler
 * 
 * Handles form submission protection for the complaints/suggestions form.
 */

import { protectFormSubmission } from './form-submit-protection.js';

document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('complaintsForm');
  const submitBtn = document.getElementById('complaintsSubmitBtn');

  if (form && submitBtn) {
    protectFormSubmission(form, submitBtn);
  }
});

